import { memo } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { useHistory } from 'react-router';
import { PerformancePath } from 'reports/cw/constants/cw.constant';
import { appSelectors } from 'redux/ducks/app';
import { courseSelectors } from 'reports/cw/redux/ducks/courses';
import { ANALYTIC_FEATURES, FeatureFlagNames } from 'constants/app.constant';
import { EXTERNAL_APP_INFO } from 'constants/externalApp.constant';
import { isEABAppByAppName } from 'services/app-linking.service';
import { isEAQStandalone } from 'reports/cw/services/courses.service';
import { trackAAFeature } from 'services/adobe-analytics.service';
import { isEnabledMockService } from 'helpers/app.helper';
import { isFeatureEnabled } from 'services/feature-flag.service';
import withRedirectToOutsideApp from '../with-redirect-to-outside-app/withRedirectToOutsideApp';
import LinkButton from '../link-button/LinkButton';
var CoursePicker = function (_a) {
    var pendoClass = _a.pendoClass, currentCourseName = _a.currentCourseName, _b = _a.isViewAllCoursesHidden, isViewAllCoursesHidden = _b === void 0 ? false : _b, onRedirectToOutsideApp = _a.onRedirectToOutsideApp;
    var history = useHistory();
    var breadcrumbBackTitle = useSelector(appSelectors.getBreadcrumbBackTitle);
    var courseSectionInfo = useSelector(courseSelectors.getCourseSectionInfo);
    var featureFlags = useSelector(appSelectors.getFeatureFlags);
    var isMockServiceEnabled = isEnabledMockService();
    var enableEaqPerformanceAppRedirect = isFeatureEnabled(featureFlags, FeatureFlagNames.ENABLE_EAQ_PERFORMANCE_APP_REDIRECT);
    var handleViewAllCourse = function () {
        trackAAFeature(ANALYTIC_FEATURES.CW_INSTRUCTOR_HOME_VIEW_ALL_COURSES_CLICK);
        history.push(PerformancePath.courseAggregate);
    };
    var handleViewMyCoursePlan = function () {
        if (!isMockServiceEnabled) {
            trackAAFeature(ANALYTIC_FEATURES.CW_INSTRUCTOR_HOME_VIEW_MY_COURSE_PLAN_CLICK);
            var linkConfig = {
                appName: EXTERNAL_APP_INFO.APP_LINKING.SHER_EVOL.APP_NAME,
                action: EXTERNAL_APP_INFO.APP_LINKING.SHER_EVOL.ACTION.PERFORMANCE_VIEW
            };
            onRedirectToOutsideApp(linkConfig);
        }
    };
    var shouldShowViewMyCoursePlanButton = !isEABAppByAppName(breadcrumbBackTitle) && (enableEaqPerformanceAppRedirect || !isEAQStandalone(courseSectionInfo));
    return (<div className="u-els-background-color-n0 c-course-picker">
      <div className="u-els-display-flex o-els-flex-layout--middle u-max-width-1400 u-els-margin-auto u-els-padding-left-1x1o2 u-els-padding-right-1x1o2">
        <div className="u-els-font-size-base u-els-font-family-bold u-els-padding-right-1o2">Viewing Course:</div>
        <LinkButton onClick={handleViewMyCoursePlan} className="u-els-padding-top u-els-margin-bottom u-cursor-pointer c-course-picker__title" disabled={isMockServiceEnabled}>
          {currentCourseName}
        </LinkButton>
        {shouldShowViewMyCoursePlanButton && (<LinkButton onClick={handleViewMyCoursePlan} className="u-els-margin-left-2x u-els-font-size-base c-els-link c-course-picker__view-my-course-plan" disabled={isMockServiceEnabled}>
            View My Course Plan
          </LinkButton>)}
        {pendoClass && !isViewAllCoursesHidden && (<span className="u-els-font-size-base c-course-picker__view-all-courses">
            <LinkButton onClick={handleViewAllCourse} className={classNames('c-els-link c-course-picker__view-all-courses-button', "js-pendo-".concat(pendoClass))}>
              View all Courses
            </LinkButton>
          </span>)}
      </div>
    </div>);
};
export { CoursePicker as CoursePickerBase };
export default memo(withRedirectToOutsideApp(CoursePicker));
